import {Component, Input} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {FechaComponent} from '../fecha/fecha.component';
import {DateTime} from 'luxon';
import {SharedService} from '../../services/shared.service';

@Component({
  selector: 'app-masivo',
  templateUrl: './masivo.component.html',
  styleUrls: ['./masivo.component.scss'],
})
export class MasivoComponent {

  @Input() rutina: string = '';

  estate = {
    primero: '',
    segundo: '',
    postre: '',
    merienda: '',
    desayuno: '',
    almuerzo: '',
    i1: 'INICIO',
    f1: 'FINAL',
    i2: 'INICIO',
    f2: 'FINAL',
    horaInicioSiesta1: 0,
    horaFinalSiesta1: 0,
    horaInicioSiesta2: 0,
    horaFinalSiesta2: 0
  };

  constructor(
    private shared: SharedService,
    public modalCtrl: ModalController
  ) {}

  fill = (rutina: string, valor: string): 'clear' | 'outline' | 'solid' | 'default' => this.estate[rutina] === valor ? 'solid' : 'outline';

  save = (rutina: string, valorRutina: string) => this.estate[rutina] = valorRutina;

  siesta = async (ident: string) => {
    let timeValue: string = DateTime.local().toISO();
    if (this.estate[ident] !== 'INICIO' && this.estate[ident] !== 'FINAL') {
      timeValue = DateTime.fromISO(this.estate[ident]).toISO();
    }
    const modal = await this.modalCtrl.create({
      component: FechaComponent,
      componentProps: {tipo: 'time', fecha: timeValue, now: true, borrar: true},
      cssClass: 'modalHora borde'
    })
    await modal.present();
    const val = await modal.onDidDismiss();
    if (!val.role) {
      await this.saveHora(ident, DateTime.fromISO(val.data.detail.value).toFormat('HH:mm'));
      return
    }
    if (val.role === 'clear') {
      this.borrar(ident);
    }
  }

  private saveHora = async (ident: string, hora: string) => {
    const valorHora = this.shared.setHora(hora);
    switch (ident) {
      case 'i1': {
        this.estate.i1 = hora;
        this.estate.horaInicioSiesta1 = valorHora;
        if (this.estate.horaInicioSiesta1 >= this.estate.horaFinalSiesta1 && this.estate.horaFinalSiesta1 > 0) {
          this.estate.f1 = 'FINAL';
          this.estate.horaFinalSiesta1 = 0;
        }
        if (this.estate.horaInicioSiesta1 >= this.estate.horaInicioSiesta2 && this.estate.horaInicioSiesta2 > 0) {
          this.estate.i2 = 'INICIO';
          this.estate.f2 = 'FINAL';
          this.estate.horaInicioSiesta2 = 0;
          this.estate.horaFinalSiesta2 = 0;
          await this.shared.mostrarToast('Horas de la siesta 2 borradas, no pueden ser menores', true);
        }
        break
      }
      case 'f1': {
        if (valorHora > this.estate.horaInicioSiesta1) {
          this.estate.f1 = hora;
          this.estate.horaFinalSiesta1 = valorHora;
          if (this.estate.horaFinalSiesta1 >= this.estate.horaInicioSiesta2 && this.estate.horaInicioSiesta2 > 0) {
            this.estate.i2 = 'INICIO';
            this.estate.f2 = 'FINAL';
            this.estate.horaInicioSiesta2 = 0;
            this.estate.horaFinalSiesta2 = 0;
            await this.shared.mostrarToast('Horas de la siesta 2 borradas, no pueden ser menores', true);
          }
        } else {
          await this.shared.mostrarToast('Hora final no puede ser menor que hora inicial', true);
        }
        break
      }
      case 'i2': {
        if (valorHora > this.estate.horaFinalSiesta1) {
          this.estate.i2 = hora;
          this.estate.horaInicioSiesta2 = valorHora;
          if (this.estate.horaInicioSiesta2 >= this.estate.horaFinalSiesta2 && this.estate.horaFinalSiesta2 > 0) {
            this.estate.f2 = 'FINAL';
            this.estate.horaFinalSiesta2 = 0;
            await this.shared.mostrarToast('Hora final no puede ser menor que hora inicial', true);
          }
        } else {
          await this.shared.mostrarToast('Hora inicio siesta 2 no puede ser menor que hora final siesta 1', true);
        }
        break
      }
      case 'f2': {
        if (valorHora > this.estate.horaInicioSiesta2) {
          this.estate.f2 = hora;
          this.estate.horaFinalSiesta2 = valorHora;
        } else {
          await this.shared.mostrarToast('Hora final no puede ser menor que hora inicial', true);
        }
        break
      }
    }
  }

  nosavesiesta = (): boolean => {
    if (this.estate.i1 === 'INICIO') return true;
    if (this.estate.i1 !== 'INICIO' && this.estate.f1 === 'FINAL') return true;
    return this.estate.i1 !== 'INICIO' && this.estate.f1 !== 'FINAL' && this.estate.i2 !== 'INICIO' && this.estate.f2 === 'FINAL';
  }

  nosavecomida = (): boolean => this.estate.primero === '' && this.estate.segundo === '' && this.estate.postre === '';

  nosaveresto = (): boolean => this.estate[this.rutina] === '';

  private borrar = (ident: string) => {
    if (ident === 'i1' && this.estate.i1 !== 'INICIO') {
      this.estate.i1 = 'INICIO';
      this.estate.f1 = 'FINAL';
      this.estate.i2 = 'INICIO';
      this.estate.f2 = 'FINAL';
      this.estate.horaInicioSiesta1 = 0;
      this.estate.horaFinalSiesta1 = 0;
      this.estate.horaInicioSiesta2 = 0;
      this.estate.horaFinalSiesta2 = 0;
      return
    }
    if (ident === 'f1' && this.estate.f1 !== 'FINAL') {
      this.estate.f1 = 'FINAL';
      this.estate.i2 = 'INICIO';
      this.estate.f2 = 'FINAL';
      this.estate.horaFinalSiesta1 = 0;
      this.estate.horaInicioSiesta2 = 0;
      this.estate.horaFinalSiesta2 = 0;
      return
    }
    if (ident === 'i2' && this.estate.i2 !== 'INICIO') {
      this.estate.i2 = 'INICIO';
      this.estate.f2 = 'FINAL';
      this.estate.horaInicioSiesta2 = 0;
      this.estate.horaFinalSiesta2 = 0;
      return
    }
    if (ident === 'f2' && this.estate.f2 !== 'FINAL') {
      this.estate.f2 = 'FINAL';
      this.estate.horaFinalSiesta2 = 0;
    }
  }

}
